var map = {
	"./CRMWhatsappMessage.mp3": 80721,
	"./CRMWhatsappMessageNotification.mp3": 62000,
	"./errorSystemNotificationDialog.mp3": 70210,
	"./newCRMWhatsappInvoice.mp3": 21499,
	"./rejectCRMWhatsappConversation.mp3": 16698,
	"./requestCRMWhatsappConversationTransfer.mp3": 97093,
	"./successSystemNotificationDialog.mp3": 67889
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46981;